<template>
  <div class='flex flex-column align-center py-10'>
    <v-img
      lazy-src='@/assets/icons/svg/check-color.svg'
      src='@/assets/icons/svg/check-color.svg'
      max-width='150'
    />
    <h6 class='mt-6 text-center font-weight-bold'>Connection is confirmed!</h6>
    <h6 class='mt-1 text-center font-weight-bold'>You will redirect to the integration settings page in few seconds...</h6>
  </div>
</template>

<script>
import service from '@/services/integrations'
export default {
  async created() {
    const payload = {
      system: this.$route.params.system,
      data: {
        url: this.$route.fullPath
      }
    }
    const response = await service.oAuthConfirm(payload)
    if (response?.data?.error?.type === 200) {
      this.$store.commit('integrations/setIntegrationInfo', response.data.data)

      setTimeout(() => {
        this.$router.replace({
          name: 'IntegrationSyncContinue',
          params: {
            system: response.data.data.alias,
            warehouse: response.data.data.warehouse.id
          }
        })
      }, 3500)
    } else {
      this.$showError('Error to connect', response?.data?.error?.message || 'The error has occurred during execution of the operation.')
    }
  }
}
</script>
